import api from '../api';

export const getListSection = async () => {
    const result = await api.get('/admin/section');
    return result.data.data;
}

export const getOneSection = async (id) => {
    const result = await api.get(`/admin/section/${id}`);
    return result.data.data;
}

export const createSection = async (data, lang) => {
    try {
        const response = await api.post('/admin/section', data, {
            headers: {
                "Accept-Language": lang
            }
        });
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateSection = async (data, id, lang, idPage) => {
    return await api.post(`/admin/section/${id}/${idPage}`, data, {
        headers: {
            "Accept-Language": lang
        }
    });
}

export const deleteSection = async (id) => {
    try {
        const response = await api.delete(`/admin/section/${id}`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateStatusSection = async (id) => {
    try {
        const response = await api.put(`/admin/section/${id}/status`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const addField = async (data, id) => {
    try {
        const response = await api.post(`/admin/field/new/${id}`, data);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateOrderItem = async (data, id) => {
    try {
        const response = await api.post(`/admin/item/${id}/order`, data);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

